<template>
    <div id="all-review-content">
        <vs-col class="w-2/3 pr-6" v-if="gocheckinReviewList.length != 0 || yelpReviewList.length != 0 || googleReviewList.length != 0">
          <!-- <div v-for="(review, index) in gocheckinReviewList" :key="'a' + index">
              <item-go-checkin-review :infoObj="infoObj" :reviewData="review"></item-go-checkin-review>
          </div> -->

          <!-- <div v-for="(review, index) in yelpReviewList" :key="'b' + index">
              <item-yelp-review :reviewData="review"></item-yelp-review>
          </div> -->

          <!-- <div v-for="(review, index) in googleReviewList" :key="'c' + index">
              <item-google-review :infoObj="infoObj" :reviewData="review"></item-google-review>
          </div> -->

          <div v-if="reviewData && reviewData.items">
            <div v-for="(review, index) in reviewData.items" :key="index">
              <div v-if="review.type == 'gocheckin'">
                <item-go-checkin-review :infoObj="infoObj" :reviewData="review"></item-go-checkin-review>
              </div>
              <div v-else-if="review.type == 'google' || review.type == 'google_gmb'">
                <item-google-review :infoObj="infoObj" :reviewData="review"></item-google-review>
              </div>
            </div>
          </div>

          <div class="my-3" v-if="reviewData._meta.pageCount && reviewData._meta.pageCount > 1">
            <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(reviewData._meta.pageCount)" :currentPage="curPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
          </div>
        </vs-col>

        <vs-col class="w-2/3 pr-6 text-center mt-base" v-else>
          No data available
        </vs-col>

        <vs-col class="w-1/3 right-col" v-if="reviewReport">
            <vx-card class="mb-6 mt-3">
              <div class="text-xl mb-6 flex align-center justify-between">
                <span class="card-title font-semibold color-black">Total Survey Send Out</span>
                <span class="text-25xl font-bold ml-3 color-black">{{reviewReport.total_survey}}</span>
              </div>
              <div class="w-full review-chart" v-if="isLoaded">
                <vue-apex-charts type='radialBar' height='240' :options="chartOptions" :series="series"/>
              </div>
              <div>
                <div class="flex align-center justify-between">
                  <div>
                    <div class="div-color"></div>
                  </div>
                  <div
                    class="text-sm px-4 pr-3 color-black"
                  >Number Of Customers Writing Reviews Into Go Check In System</div>
                  <div class="text-2xl text-center font-bold color-black">{{reviewReport.customer_write_review_into_system}}</div>
                </div>
              </div>
            </vx-card>
            <vx-card class="mb-6 mt-3">
              <p class="text-xl mb-1 card-title font-semibold color-black">Google Review At Signed Up</p>
              <div class="flex mb-3" v-if="reviewReport.google_review_at_sign_up">
                <star-rating :rating="reviewReport.google_review_at_sign_up.average_rating" :read-only="true" :increment="0.1" class="mr-3"></star-rating>
                <span class="mt-2">{{reviewReport.google_review_at_sign_up.average_rating}} Star/ {{reviewReport.google_review_at_sign_up.total_reviews}} Reviews</span>
              </div>

              <p class="text-xl mb-1 card-title font-semibold color-black">Current Google Review</p>
              <div class="flex" v-if="reviewReport.google_review_current">
                <star-rating :rating="reviewReport.google_review_current.average_rating" :read-only="true" :increment="0.1" class="mr-3"></star-rating>
                <span class="mt-2">{{reviewReport.google_review_current.average_rating}} Star/ {{reviewReport.google_review_current.total_reviews}} Reviews</span>
              </div>
            </vx-card>
            <vx-card class="mb-6">
              <p class="text-xl mb-6 card-title font-semibold color-black">Customers Gave Ratings Into Go Check In System</p>
              <div>
                <!-- <div class="flex align-center mb-2">
                  <span class="cursor-pointer"><vs-icon icon="sentiment_very_satisfied" size="medium" @click="emotionalFilter(5)"></vs-icon></span>
                  <span class="text-xl ml-5">{{reviewReport.customer_give_rating_into_system.five_star}} Clicks</span>
                </div>
                <div class="flex align-center mb-2">
                  <span class="cursor-pointer"><vs-icon icon="sentiment_dissatisfied" size="medium" @click="emotionalFilter(3)"></vs-icon></span>
                  <span class="text-xl ml-5">{{reviewReport.customer_give_rating_into_system.three_star}} Clicks</span>
                </div>
                <div class="flex align-center mb-2">
                  <span class="cursor-pointer"><vs-icon icon="sentiment_very_dissatisfied" size="medium" @click="emotionalFilter(1)"></vs-icon></span>
                  <span class="text-xl ml-5">{{reviewReport.customer_give_rating_into_system.one_star}} Clicks</span>
                </div> -->

                <div class="emotional-container">
                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn very-unhappy emotional-active" @click="emotionalFilter(1)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.one_star">{{reviewReport.customer_give_rating_into_system.one_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>
                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn unhappy emotional-active" @click="emotionalFilter(2)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.two_star">{{reviewReport.customer_give_rating_into_system.two_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn normal emotional-active" @click="emotionalFilter(3)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.three_star">{{reviewReport.customer_give_rating_into_system.three_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn happy emotional-active" @click="emotionalFilter(4)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.four_star">{{reviewReport.customer_give_rating_into_system.four_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn very-happy emotional-active" @click="emotionalFilter(5)">
                              <span></span>
                              <div class="content" v-if="reviewReport.customer_give_rating_into_system.five_star">{{reviewReport.customer_give_rating_into_system.five_star}} Clicks</div>
                              <div class="content" v-else>0 Clicks</div>
                          </vs-button>
                      </div>
                  </div>
                </div>
              </div>
            </vx-card>
            <vx-card class="mb-6">
              <p class="text-xl mb-3 card-title font-bold color-black">Go-Checkin Reviews</p>
              <p class="text-4xl font-bold">{{reviewReport.total_gocheckin_review}}</p>
            </vx-card>
            <!-- <vx-card class="mb-6 card-title">
              <p class="text-xl mb-3">Yelp Reviews</p>
              <p class="text-4xl font-bold">{{reviewReport.total_yelp_review}}</p>
            </vx-card> -->
            <vx-card class="">
              <p class="text-xl mb-3 card-title font-bold color-black">Google Reviews</p>
              <p class="text-4xl font-bold">{{reviewReport.total_google_review}}</p>
            </vx-card>
          </vs-col>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StarRating from "vue-star-rating";
    export default {
        name: 'all-review-content',
        components: {
          StarRating,
          VueApexCharts
        },
        props: {
          search: {
            type: String
          },
          sort_by: {
            type: Object
          },
          currentPage: {
            type: Number,
            default: 1
          },
          itemsPerPage: {
            type: Number
          }
        },
        data() {
            const obj = {
              page: this.currentPage,
              "per-page": this.itemsPerPage,
              user_name: this.search,
            }
            if(this.sort_by && this.sort_by.id != 0) {
              obj.sort = this.sort_by.value;
            }
            let infoObj = obj;
            this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
              this.$emit('GetDataComplete');
            });


            let isLoaded = false;
            let chartOptions = this.$store.getters['reviewList/chartOptions'];
            let series = [];
            let data = this.$store.getters['reviewList/reviewReport'];
            if(data && data.total_survey > 0) {
              let ratio = (parseInt(data.customer_write_review_into_system) / parseInt(data.total_survey) * 100).toFixed(1);
              series.push(ratio);
              isLoaded = true;
            }
          return {
            curPage: this.currentPage,
            isLoaded,
            chartOptions,
            series,
            isOpenLoading: false,
            page_key: 0,
            infoObj
          }
        },
        methods: {
          openLoadingInDiv(){
            this.$vs.loading({
              container: '#list-review',
              scale: 0.8
            })
            if (this.loadTime) {
              clearTimeout(this.loadTime);
              this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: 'Get list all review failed',
                  acceptText: 'OK'
                })
              }
            }, 10000);

          },
          closeLoading() {
            this.$vs.loading.close('#list-review > .con-vs-loading');
            this.isOpenLoading = false;
          },
          changePage(curPage) {
              const obj = {
                  page: curPage,
                  "per-page": this.itemsPerPage,
                  user_name: this.search,
              }
              if(this.sort_by && this.sort_by.id != 0) {
                obj.sort = this.sort_by.value;
              }
              this.infoObj = obj;
              if(!this.isOpenLoading) {
                this.openLoadingInDiv();
              }
              this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
                this.closeLoading();
                this.$emit('ChangePage', curPage);
                this.page_key++;
              })
          },
          emotionalFilter(rating) {
            this.$emit('EmotionalFilter', rating);
          }
        },
        computed: {
            googleReviewList() {
                return this.$store.getters["reviewList/reviewListByType"]('google');
            },
            gocheckinReviewList() {
                return this.$store.getters["reviewList/reviewListByType"]('gocheckin');
            },
            yelpReviewList() {
                return this.$store.getters["reviewList/reviewListByType"]('yelp');
            },
            reviewData() {
                return this.$store.getters["reviewList/reviewData"];
            },
            reviewReport() {
              return this.$store.getters['reviewList/reviewReport'];
            }
        },
        created() {
          this.$emit('ChangeReview', 'all');
        }
    }
</script>
